import { useEffect } from 'react';
import classes from './EventModal.module.css';
import { getEventStatus } from '../../utils/eventStatus';

export default function EventModal({ event, onClose }) {
    useEffect(() => {
        if (!event) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [event, onClose]);

    if (!event) {
        return null;
    }

    const { title, date, time, location, mapUrl, registrationUrl, resultsUrl, description, imageUrl, videoUrl } = event;
    const displayDate = new Date(date).toLocaleDateString('en-IE', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    // BS: compute live (not the stored status) so an event that happened earlier today shows RESULTS
    const isPast = getEventStatus(date, time) === 'past';

    return (
        <div className={classes.overlay} onClick={onClose}>
            <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
                <button className={classes.close} onClick={onClose} aria-label="Close">✕</button>
                {imageUrl && (
                    <img className={classes.image} src={imageUrl} alt={title} />
                )}
                <h2 className={classes.title}>{title}</h2>
                <p className={classes.meta}>
                    {displayDate} {time && `· ${time}`}{' '}
                    {location && (
                        mapUrl ? (
                            <>
                                ·{' '}
                                <a
                                    className={classes.location_link}
                                    href={mapUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {location}
                                </a>
                            </>
                        ) : (
                            `· ${location}`
                        )
                    )}
                </p>
                {description && <p className={classes.description}>{description}</p>}
                {isPast
                    ? resultsUrl && (
                        <a
                            className={classes.resultsButton}
                            href={resultsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            RESULTS
                        </a>
                    )
                    : registrationUrl && (
                        <a
                            className={classes.registerButton}
                            href={registrationUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            REGISTER
                        </a>
                    )}
                {videoUrl && (
                    <div className={classes.videoWrapper}>
                        <iframe
                            className={classes.video}
                            src={videoUrl}
                            title={title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
